import { AbstractEntity } from "../AbstractEntity";
export default class User extends AbstractEntity {
    userName;
    name;
    password;
    keyId;
    publicKey;
    privateKey;
    privateKeySalt;
    encryptionPublicKey;
    encryptionPrivateKey;
    encryptionPrivateKeySalt;
    roles;
    constructor(user = {}) {
        super();
        Object.assign(this, { roles: [] }, user);
    }
}
//# sourceMappingURL=User.js.map